import { render, staticRenderFns } from "./categoryCb.vue?vue&type=template&id=070a4520&"
import script from "./categoryCb.vue?vue&type=script&lang=js&"
export * from "./categoryCb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports